(function() {
  // Função que faz o swap LQIP → full-res
  function replaceImage(img) {
    img.src = img.dataset.src;
    img.classList.remove('lqip');
    const pic = img.closest('picture.lazy');
    if (pic) {
      pic.querySelectorAll('source').forEach(s => {
        if (s.dataset.srcset) s.srcset = s.dataset.srcset;
      });
      pic.classList.remove('lazy');
    }
  }

  // No DOMContentLoaded: menu toggle + iniciar observer de imagens
  document.addEventListener('DOMContentLoaded', function() {
    // 1) Toggle do menu mobile
    const btn = document.querySelector('.menu-toggle');
    const nav = document.querySelector('nav');
    if (btn && nav) {
      btn.addEventListener('click', () => nav.classList.toggle('open'));
    }

    // 2) Swap LQIP → full-res via IntersectionObserver
    const imgs = document.querySelectorAll('picture.lazy img.lqip');
    if (!('IntersectionObserver' in window)) {
      // Fallback: troca todas imediatamente
      imgs.forEach(replaceImage);
    } else {
      const io = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          replaceImage(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '200px' });
      imgs.forEach(img => io.observe(img));
    }
  });

  // No window.load: registrar o Service Worker
  window.addEventListener('load', function() {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker
        .register('{{ "service-worker.js" | asset_url }}')
        .then(reg => console.log('SW registrado:', reg.scope))
        .catch(err => console.error('Falha no registro do SW:', err));
    }
  });
})();